import {useActions} from "../../../../hooks/useActions";
import {useTypedSelector} from "../../../../hooks/useTypedSelector";
import {SoundsService} from "../../../../services/SoundsService";
import {sounds} from "../../../../sounds/sound";

function BossIconComponent({story, className, isPromo = false}) {

    const {user, tutorial} = useTypedSelector(state => state.auth);

    const {setCpuStory, setTutorial, setRoute} = useActions();

    className += ' map-ico';

    const tutorialAction = function () {
        if (tutorial.step === 'ClickBossOnMap20') {
            tutorial.step = 'BossWindow30';
            setTutorial(tutorial);
        }
        if (tutorial.step === 'Final150') {
            tutorial.step = 'none';
            tutorial.isActive = false;
            setTutorial(tutorial);
        }
    }

    if (tutorial.step === 'ClickBossOnMap20' && className === 'map-tutorial-ico map-ico') {

        className += ' defaultButtonAnimation_2_5';
    }

    if (tutorial.step === 'Final150' && className === 'map-lust-tower-ico map-ico') {

        className += ' defaultButtonAnimation_2_5';
    }


    if (story.level > user.level) {
        className += ' map-ico-gray';
    }

    let classNameStar1 = 'map_star_bg_empty';
    if (user.maps.find((element: any) => element === story.cpu1.id)) {
        classNameStar1 = 'map_star_bg_filled';
    }
    let classNameStar2 = 'map_star_bg_empty';
    if (user.maps.find((element: any) => element === story.cpu2.id)) {
        classNameStar2 = 'map_star_bg_filled';
    }
    let classNameStar3 = 'map_star_bg_empty';
    if (user.maps.find((element: any) => element === story.cpu3.id)) {
        classNameStar3 = 'map_star_bg_filled';
    }
    if (story.level <= user.level) {
        if (classNameStar1 === 'map_star_bg_empty') {
            classNameStar1 += ' map_star_bg_empty_Animations'
        }
        if (classNameStar2 === 'map_star_bg_empty') {
            classNameStar2 += ' map_star_bg_empty_Animations'
        }
        if (classNameStar3 === 'map_star_bg_empty') {
            classNameStar3 += ' map_star_bg_empty_Animations'
        }
    }

    if (story.isPromo) {
        classNameStar1 = '';
        classNameStar2 = '';
        classNameStar3 = '';
    }

    let showBL = false;
    let blClasses = 'map-bl-empty map_star_bg_empty_Animations'
    if (user.level > 3 && story.cpu4  && (user.maps.find(element => element === story.cpu3.id))) {
        showBL = true;
    }
    if (showBL && user.maps.find((element: any) => element === story.cpu4.id)) {
        blClasses = 'map_bl_filled';
    }

    return (
        <div className={className} onClick={() => {
            SoundsService.playSound(sounds.menu_open_popup());
            tutorialAction();
            setCpuStory({
                story: story,
                cpuId: story.cpu1.id,
                cpuNumber: 'cpu1',
                action: null,
                isPromo: isPromo
            });
            setRoute('boss');
        }}>
            <div className={'map_star map_star_1 ' + classNameStar1}></div>
            <div className={'map_star map_star_2 ' + classNameStar2}></div>
            <div className={'map_star map_star_3 ' + classNameStar3}></div>
            {(showBL) ?
                <div className={blClasses + ' mp-bl'}></div>
                : null
            }

        </div>
    );
}

export default BossIconComponent;
